// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"9ad080d8","232":"f82a6e02","237":"fa14a3ec","526":"b557d281","787":"6375121b","845":"0664bf16"}[chunkId] + ".chunk.js";
};